const C = require("../constants");

function PaymentDialogReducer(state = {is_open:false}, action) {
    switch (action.type) {
        case C.PAYMENT_DIALOG:
            return action.is_open;
        default:
            return state;
    }
};

export default PaymentDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/PaymentDialogReducer.js